import { combineReducers } from 'redux';
import calendar from './reducers/calendar';
import blockedTimes from './reducers/blockedTimes';
import appointments from './reducers/appointments';
import loadedDate from './reducers/loadedDate';
import workday from './reducers/workday';

export default combineReducers({
  calendar,
  blockedTimes,
  appointments,
  loadedDate,
  workday,
});
